/** Site name in document titles (WCAG 2.4.2 / EL–E2). */
export const SITE_NAME = 'EasyLlama';

/**
 * `{course} – {sequence} | EasyLlama` when both exist;
 * falls back to course or sequence alone, then site name.
 */
export function formatDocumentTitle(
  courseTitle?: string | null,
  sequenceTitle?: string | null
): string {
  const course = courseTitle?.trim() || '';
  const sequence = sequenceTitle?.trim() || '';

  if (course && sequence) {
    return `${course} – ${sequence} | ${SITE_NAME}`;
  }
  if (course) {
    return `${course} | ${SITE_NAME}`;
  }
  if (sequence) {
    return `${sequence} | ${SITE_NAME}`;
  }
  return SITE_NAME;
}
